import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useWatch } from 'react-hook-form'
import DepositsCount from '../depositsCount';
import DepositsSum from '../depositsSum';
import CasinoWager from '../casinoWager';
import FirstDeposit from '../firstDeposit';
import EffectiveDepositsSum from '../effectiveDepositsSum';
import SbBetsSum from '../sbBetsSum';
import Registration from '../registration';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '100%',
    },
}))
const QualifierItem = ({
    idxQualifiers,
    idxRules,
    idx,
    control,
    register
}) => {
    const classes = useStyles();

    const qualifiers = [
        { name: 'deposits_count', value: 'deposits_count' },
        { name: 'deposits_sum', value: 'deposits_sum' },
        { name: 'first_deposit', value: 'first_deposit' },
        { name: 'effective_deposits_sum', value: 'effective_deposits_sum' }
    ];

    const type = useWatch({
        control,
        name: `ruleGroup[${idx}].rules[${idxRules}].qualifiers[${idxQualifiers}].rule.type`
    })

    return (
        <div style={{ paddingLeft: 20 }}>
            <label htmlFor="title" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                <span className={classes.helper}>Тип</span>
                <select
                    {...register(`ruleGroup[${idx}].rules[${idxRules}].qualifiers[${idxQualifiers}].rule.type`)}
                    style={{ height: '34px', width: '100%' }}
                    className={classes.text}
                >
                    <option value="" style={{ display: 'none' }}>Выбрать условие</option>
                    {
                        qualifiers.map((item) => <option value={item.name}>{item.name}</option>)
                    }
                </select>
            </label>
            {
                type === 'deposits_count' && (
                    <DepositsCount
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
            {
                type === 'deposits_sum' && (
                    <DepositsSum
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
            {
                type === 'casino_wager' && (
                    <CasinoWager
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
            {
                type === 'first_deposit' && (
                    <FirstDeposit
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
            {
                type === 'effective_deposits_sum' && (
                    <EffectiveDepositsSum
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
            {
                type === 'sb_bets_sum' && (
                    <SbBetsSum
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
            {
                type === 'registration' && (
                    <Registration
                        idx={idx}
                        idxRules={idxRules}
                        idxQualifiers={idxQualifiers}
                        register={register}
                    />
                )
            }
        </div>
    )
}

export default QualifierItem;